import { createClient } from '@supabase/supabase-js'

// Captured BEFORE createClient runs, and this ordering is load-bearing.
//
// `detectSessionInUrl: true` makes supabase-js parse the auth fragment and then
// STRIP it from the address bar. By the time any component renders, the hash is
// gone -- so "how did this person arrive" has to be recorded here, at module
// load, or it is lost.
//
// It matters because an invite link and a password-reset link fire DIFFERENT
// events. A reset fires PASSWORD_RECOVERY. An invite fires plain SIGNED_IN,
// indistinguishable from a normal login, which is how an invited teammate ended
// up signed in having never chosen a password -- fine until the session expired
// and they could never get back in. `type` is the only thing that tells them
// apart, and it lives in the fragment.
export const INITIAL_AUTH_TYPE = (() => {
  try {
    const raw = window.location.hash.replace(/^#/, "");
    if (!raw) return "";
    return new URLSearchParams(raw).get("type") || "";
  } catch {
    return "";
  }
})();

export const supabase = createClient(
  "https://cshfvhzmvkzrvlyrnfap.supabase.co",
  "sb_publishable_hvkz4Ozbxq-SzJRyWDLyEA_B2-1vJtV",
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    }
  }
)
